import React from 'react';
import PropTypes from 'prop-types';
import { useWizard } from 'react-use-wizard/dist/index';
import { Button, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    width: '100%'
  }
}));

const DefaultFooter = ({ handleNext, disabled }) => {
  const { previousStep, nextStep, isLastStep, isFirstStep, handleStep } = useWizard();
  const { t } = useTranslation();
  const classes = useStyles();

  handleStep(() => {
    handleNext();
  });

  return (
    <div className={classes.container}>
      <Button
        disabled={isFirstStep}
        color='primary'
        variant='contained'
        onClick={() => previousStep()}>
        {t('wizardBulkNotification:previous')}
      </Button>
      { isLastStep ? <Button
        color='primary'
        variant='contained'
        onClick={() => handleNext(isLastStep)}>
        {t('wizardBulkNotification:submit')}
      </Button>
        : <Button
          disabled={!disabled}
          color='primary'
          variant='contained'
          onClick={() => nextStep()}>
          {t('wizardBulkNotification:next')}
        </Button>
      }
    </div>
  );
};

DefaultFooter.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default DefaultFooter;
